module.exports = __webpack_public_path__ + "img/haed-interior.a3c8bc8a.png";